import { AnyAction } from '@reduxjs/toolkit'

import {
  ADD_ORGANIZATION_ADMIN_SUCCESS,
  FETCH_ORG_USERS_TO_ADD_SUCCESS,
  FETCH_ORGANIZATION_ADMINS_SUCCESS,
  REMOVE_ORGANIZATION_ADMIN_SUCCESS
} from './actionTypes'

export type OrganizationSettingsPageState = {
  users?: any[]
  searchedUsers?: any[]
}

export const initialState: OrganizationSettingsPageState = {}

export default function organizationSettingsEditPageReducer(
  state = initialState,
  action: AnyAction
): OrganizationSettingsPageState {
  switch (action.type) {
    case FETCH_ORGANIZATION_ADMINS_SUCCESS: {
      return setOrganizationAdmins(action.response)
    }
    case FETCH_ORG_USERS_TO_ADD_SUCCESS: {
      return { ...state, searchedUsers: action.response.resources.map(({ id }: { id: string }) => id) }
    }
    case REMOVE_ORGANIZATION_ADMIN_SUCCESS: {
      return removeOrganizationAdmin(action.response)
    }
    case ADD_ORGANIZATION_ADMIN_SUCCESS: {
      return addOrganizationAdmin(action.response)
    }
    default: {
      return state
    }
  }

  function setOrganizationAdmins(users: any[]) {
    if (users) {
      const OrganizationAdmins = users.map(user => user.id)
      return { ...state, users: OrganizationAdmins }
    }

    return { ...state, users: [] }
  }

  function removeOrganizationAdmin(user: any) {
    const users = state.users?.filter(item => {
      return item !== user.id
    })
    return { ...state, users: users }
  }

  function addOrganizationAdmin(user: any) {
    if (state.users) {
      return { ...state, users: [...state.users, user.id] }
    } else {
      return { ...state, users: [user.id] }
    }
  }
}
